import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CheckSquareOutlined } from '@ant-design/icons';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { OrderStatusEditModal } from './components/order-status-edit-modal';
import type { IOrderStatusEditModalProps } from './components/order-status-edit-modal';

interface IOrderFinancialStatusEditProps extends Pick<IOrderStatusEditModalProps, 'currentStatus' | 'orderId'> {}

export const OrderStatusEditComponent: React.FC<IOrderFinancialStatusEditProps> = (props) => {
  const { orderId, currentStatus } = props;
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <Button icon={<CheckSquareOutlined />} onClick={handleOpen}>
        {t('order:status')}
      </Button>
      <OrderStatusEditModal
        isOpen={isModalOpen}
        currentStatus={currentStatus}
        orderId={orderId}
        onClose={handleClose}
      />
    </>
  );
};

export const OrderStatusEdit = withRoleGuard<IOrderFinancialStatusEditProps>(OrderStatusEditComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
